import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';

import MLButton from '@src/components/ui/ml_button';

const LogoutModal = (props) => {
    const {
        show,
        className,
        handleLogout,
        handleCancel,
    } = props;

    const modalClasses = classnames(className, {
        'logout-modal': true,
    });

    return (
        <Modal
            centered
            show={show}
            className={modalClasses}
            contentClassName="logout-modal-content"
            onHide={handleCancel}
        >
            <Modal.Header closeButton className="logout-modal-header" />
            <Modal.Body className="text-center">
                <h1 className="logout-modal-title">Confirm Logout</h1>
                <p>Are you sure you want to log out?</p>
            </Modal.Body>
            <Modal.Footer className="logout-modal-footer pb-5">
                <div className="button-container">
                    <MLButton
                        className="mr-2"
                        onClick={handleLogout}
                    >
                        Yes, Log Out
                    </MLButton>
                    <MLButton
                        variant="secondary"
                        onClick={handleCancel}
                    >
                        Cancel
                    </MLButton>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

LogoutModal.propTypes = {
    show: PropTypes.bool.isRequired,
    className: PropTypes.string,
    handleLogout: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
};

export default LogoutModal;
